<template>
    <div class="container-fluid">
        <div class="row p-3">
            <!-- Header Wrapper to hold both rows -->
            <div class="w-100">
                
                <!-- TOP ROW: Title, Search, and Sort Dropdown -->
                <div class="designRowOrga w-100">
                    <!-- LEFT SECTION: Title or Back Button -->
                    <div class="left-header-container">
                        <div class="h3Organization" v-if="!editFlag && currentPage.btnHeaderShow">
                            <img src="../../assets/images/title-icon.png" alt="">
                            <h3 class="header-text">Settings</h3>
                        </div>
                        
                        <router-link class="back-route h1" @click="backHandler" :to="currentPage.backRoute"
                                    v-if="(editFlag || currentPage.btnBackShow) && isAction">
                            <img src="../../assets/images/back.svg" height="19">
                            {{ editFlag ? 'Edit' : 'Create' }} {{ currentPage.title.charAt(0).toUpperCase() + currentPage.title.substring(1) }}
                        </router-link>
                    </div>

                    <!-- RIGHT SECTION: Search, Sort Dropdown, and Create Button -->
                    <div class="right-header-container">
                        <div class="twoInputs">
                            <div class="btnInsideInput w-100">
                                <button @click="triggerSearch">
                                    <img src="../../assets/images/SearchIcon.png" alt="">
                                </button>
                                <input type="text" id="statusSeacrh" class="form-control" v-model="globalSearch"
                                    placeholder="Search" autocomplete="off" maxlength="50" @keyup.enter="triggerSearch">
                            </div>
                        </div>
                        
                        <!-- Inline Sort Dropdown replacing the Filter Button -->
                        <div class="sort-container mx-2">
                            <select id="filter_dates" class="form-select sort-dropdown" v-model="globalSort">
                                <option value="" disabled>Sort by Date</option>
                                <option value="asc">Oldest</option>
                                <option value="desc">Latest</option>
                            </select>
                        </div>

                        <Transition>
                            <router-link :to="currentPage.to" id="entities-btn"
                                            v-if="permissions.includes('create '+currentPage.title) && (currentPage.access && currentPage.btnShow) && isAction || isSearch"
                                            @click="btnCreateActionsHandler"
                                            class="text-decoration-none btn-container">
                                            Create 
                            </router-link>
                        </Transition>
                    </div>
                </div>

                <!-- BOTTOM ROW: Navigation Tabs as Buttons -->
                <div class="tabs-row w-100" v-if="!editFlag && currentPage.btnHeaderShow">
                    <router-link @click="btnActionsHandler('role','roles')" to="/settings/roles"
                                class="text-decoration-none tab-btn"
                                :class="{'active': subIsActive('/settings/roles')}"
                                v-if="permissions.includes('viewAny role')">Roles
                    </router-link>

                    <router-link @click="btnActionsHandler('user','user')" to="/settings/user"
                                class="text-decoration-none tab-btn"
                                :class="{'active': subIsActive('/settings/user')}"
                                v-if="permissions.includes('viewAny user')">User
                    </router-link>

                    <router-link @click="btnActionsHandler('teams','teams')" to="/settings/teams"
                                class="text-decoration-none tab-btn"
                                :class="{'active': subIsActive('/settings/teams')}"
                                v-if="permissions.includes('viewAny team')">Teams
                    </router-link>
                </div>
                
            </div>

            <!-- Page Content -->
            <router-view 
                @data-event="dataEvent" 
                :global-search="triggeredSearch" 
                :global-sort="globalSort"
            />

            <AlartModal state="success" v-if="successModal" :message="successMessage" imagePath="okImage.svg"
                        @close-modal="closeSuccessModalHandler"/>
            <AlartModal state="error" v-if="errorModal" :message="errorMessage" imagePath="close.png"
                        @close-modal="closeErrorModalHandler"/>
        </div>
    </div>
</template>

<script>
    import {reactive, onMounted, computed, defineAsyncComponent, ref, watch} from "vue";
    import {useStore} from 'vuex';
    import {useRoute} from 'vue-router';

    const AlartModal = defineAsyncComponent(() =>
        import ('./../components/AlartModal')
    );

    export default {
        name: 'settings-page',
        components: {AlartModal},
        setup() {
            const route = useRoute();
            const store = useStore();

            const globalSearch = ref('');
            const triggeredSearch = ref('');
            const globalSort = ref('desc');

            const currentPage = reactive({
                name: '',
                title: '',
                to: '',
                backRoute: '',
                access: false,
                btnBackShow: false,
                btnShow: false,
                btnHeaderShow: false
            });
            const isAction = ref(false);
            const isSearch = ref(false);
            const permissions = ref([]);
            let originalUrlPage = ref('');
            
            onMounted(async () => {
                await store.dispatch('activeTap', 'settings');
                permissions.value = await store.state.auth.permissions;
                handleRouteLogic();
            });

            watch(() => route.path, () => {
                globalSearch.value = '';
                triggeredSearch.value = '';
                globalSort.value = 'desc';
                handleRouteLogic();
            });

            const handleRouteLogic = () => {
                let urlSplit = route.path.split('/');
                let urlPage = '';
                if (urlSplit.length > 3) {
                    urlPage = urlSplit[2] === 'entities' ? 'entity' : urlSplit[2];
                    originalUrlPage.value = urlSplit[urlSplit.length - 2];
                    currentPage.btnBackShow = true;
                    currentPage.btnShow = false;
                    currentPage.btnHeaderShow = false;
                    store.dispatch('setBtnHeader', false);
                } else {
                    urlPage = urlSplit[urlSplit.length - 1] === 'entities' ? 'entity' : urlSplit[urlSplit.length - 1];
                    originalUrlPage.value = urlSplit[urlSplit.length - 1];
                    currentPage.btnBackShow = false;
                    currentPage.btnShow = true;
                    currentPage.btnHeaderShow = true;
                    store.dispatch('setBtnHeader', true)
                }

                permissions.value = store.state.auth.permissions;
                currentPage.title = urlPage === 'teams' ? 'team' : urlPage === 'roles' ? 'role' : urlPage;
                currentPage.name = urlPage === 'teams' ? 'entity' : (urlPage === 'roles' ? 'role' : urlPage);
                currentPage.to = '/settings/' + originalUrlPage.value + '/create';
                currentPage.access = permissions.value.includes('create ' + `${currentPage.name}`);
                let to = currentPage.to.split('/');
                currentPage.backRoute = store.state.settings.editFlag ? '/' + urlSplit[1] + '/' + urlSplit[2] : '/' + to[1] + '/' + to[2];
            };

            const triggerSearch = () => {
                triggeredSearch.value = globalSearch.value;
            };

            const dataEvent = (e) => {
                if(e[currentPage.title]) {
                    isAction.value = e[currentPage.title]['action'];
                    isSearch.value = e[currentPage.title]['search'];
                }
            };

            const closeSuccessModalHandler = async () => {
                await store.dispatch('setSuccessModal', false);
            };

            const closeErrorModalHandler = async () => {
                await store.dispatch('setErrorModal', false);
            };

            const btnActionsHandler = (btnTyp, pageName) => {
                currentPage.btnShow = false;
                currentPage.btnHeaderShow = true;
                store.dispatch('setBtnHeader', true)
                currentPage.btnBackShow = false;
                currentPage.title = btnTyp === 'teams' ? 'team' : btnTyp;
                currentPage.name = btnTyp === 'teams' ? 'entity' : btnTyp;
                currentPage.to = '/settings/' + pageName + '/create';
                currentPage.access = permissions.value.includes('create ' + `${currentPage.name}`);
                currentPage.backRoute = '/settings/' + pageName;
                setTimeout(() => {
                    currentPage.btnShow = true;
                }, 200)
            };

            const btnCreateActionsHandler = () => {
                currentPage.btnShow = false;
                currentPage.btnHeaderShow = false;
                store.dispatch('setBtnHeader', false)
                currentPage.btnBackShow = true;
                let to = currentPage.to.split('/');
                currentPage.backRoute = '/' + to[1] + '/' + to[2];
            };

            const backHandler = () => {
            };

            const subIsActive = (input) => {
                const paths = Array.isArray(input) ? input : [input];
                return paths.some(path => {
                    return route.path.indexOf(path) === 0
                })
            };

            return {
                permissions,
                currentPage,
                isAction,
                isSearch,
                globalSearch,
                globalSort,
                triggeredSearch,
                triggerSearch,
                editFlag: computed(() => store.state.settings.editFlag),
                successModal: computed(() => store.state.settings.successModal),
                errorModal: computed(() => store.state.settings.errorModal),
                successMessage: computed(() => store.state.settings.successMessage),
                errorMessage: computed(() => store.state.settings.errorMessage),
                dataEvent,
                closeErrorModalHandler,
                closeSuccessModalHandler,
                subIsActive,
                btnCreateActionsHandler,
                btnActionsHandler,
                backHandler
            }
        }
    }
</script>

<style scoped>
    /* ----------------------------------------- */
    /* LAYOUT STYLES                             */
    /* ----------------------------------------- */
    
    .designRowOrga {
        padding-left: 40px !important;
        padding-right: 40px;
        height: 50px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px; 
    }

    .left-header-container {
        display: flex;
        align-items: center;
    }

    .tabs-row {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        gap: 15px; 
        padding-left: 40px; 
        padding-right: 40px;
        margin-bottom: 20px;
    }

    .tab-btn {
        background-color: transparent; 
        color: #707070;
        border: 1px solid #707070; 
        padding: 6px 20px;
        border-radius: 6px; 
        font-size: 15px;
        font-weight: 500;
        transition: all 0.2s ease-in-out;
        cursor: pointer;
    }

    .tab-btn:hover {
        background-color: rgba(112, 112, 112, 0.1); 
        color: #fff; 
    }

    .tab-btn.active {
        background-color: #E95626; /* Changes the fill color to orange */
        color: white; 
        border: 1px solid #E95626; /* Matches the border to the new fill color */
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    }
    
    /* ----------------------------------------- */
    /* INLINE DROPDOWN STYLES                    */
    /* ----------------------------------------- */
    
    .sort-dropdown {
        background-color: #707070;
        color: white;
        border: none;
        padding: 6px 35px 6px 12px; /* Increased right padding to make room for the new arrow */
        border-radius: 6px;
        font-size: 15px;
        height: 35px;
        cursor: pointer;
        
        /* 1. Hides the native browser arrows */
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        
        /* 2. Adds a custom white SVG arrow */
        background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
        background-repeat: no-repeat;
        background-position: right 10px center; /* Positions the arrow 10px from the right edge */
        background-size: 16px; /* Size of the custom arrow */
    }

    /* Target Internet Explorer to remove its specific native arrow */
    .sort-dropdown::-ms-expand {
        display: none;
    }

    .sort-dropdown:focus {
        outline: none;
        box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.2);
    }

    .sort-dropdown option {
        background-color: var(--main-bg1-color, #333); 
        color: white;
    }

    /* ----------------------------------------- */
    /* GENERAL COMPONENT STYLES                  */
    /* ----------------------------------------- */

    .no-data-header{
        font-size: 18px;
    }
    ::placeholder { 
        color: #DDD !important;
        opacity: 0.5 !important; 
    }
    :-ms-input-placeholder { 
        color: #DDD !important;
    }
    ::-ms-input-placeholder { 
        color: #DDD !important;
    }
    .create-btn-text{
        font-size: 17px;
    }
    .tabcontent{
        height:73vh;
        padding-top: 0 !important;
        overflow-y: auto;
    }
    .h3Organization{
        display: flex;
        flex-direction: row;
        justify-content: start;
        align-items: center;
    }
    .h3Organization img{
        margin-bottom:0;
        padding-right: 10px;
    }
    .h3Organization h3{
        text-transform: uppercase;
        font-weight: 600;
        margin-bottom: 0;
        font-size: calc(1.1rem+0.6vw);
    }
    .right-header-container{
        display: flex;
        flex-direction: row;
        justify-content: flex-end; 
        align-items: center;
        width: 60%;
        height: 35px;
        gap: 10px; 
    }
    .right-header-container .btn-container{
        font-size: 16px;
        font-weight: normal;
        white-space: nowrap;
    }
    .twoInputs{
        width:50%;
    }
    .btnInsideInput{
        border-radius: 6px;
        background-color: #707070;
        display: flex;
        height: 35px; /* Explicit height to align perfectly with the dropdown */
    }
    .btnInsideInput button {
        background: none;
        border: none;
        padding: 0 10px;
    }
    .btnInsideInput input{
        border-radius: 6px;
        background-color: transparent; /* Updated for cleaner input */
        padding-left: 0;
        padding-top: 5px;
        padding-bottom: 0;
        border: none;
    }
    .form-control {
        color: white !important;
        display: flex;
        justify-content: left;
        width:90% !important;
        padding-left: 10px !important;
    }
    .paginationLink{
        font-size:11px;
        font-weight: bold;
        width:99%;
    }

    /* responsive style */
    @media(max-width:1280px){
        .h3Organization{
            width: 40% !important;
        }
        .h3Organization img{
            width: 5vh !important;
        }
        .right-header-container{
            width: 70%;
        }
        .twoInputs{
            margin-bottom:0 !important;
        }
        .table-container :deep(thead :first-child){
            width:20% !important;
        }
        .table-container :deep(thead :nth-child(2)){
            width:10% !important;
        }
        .table-container :deep(thead :nth-child(5)){
            width:12% !important;
        }
        .tabcontent{
            padding-top: 0 !important;
            overflow-y: scroll;
        }
    }
    @media(max-height:767px){
        .tabcontent{
            height: 69vh;
        }
    }
</style>